import { Button, Dimmer, Header } from 'semantic-ui-react';
import styled from 'styled-components';
import { CSSProperties } from 'react'

interface HeaderStyledProps {
  fontSizeHeader?: CSSProperties['fontSize']
  whiteSpaceHeaderProps?: CSSProperties['whiteSpace']
}

interface PageHeaderActionsProp {
  actionWidth?: string
  $actionNoWrap?: boolean;
}

interface ChildContainerProps {
  $childContainerSize?: string
  $childrenOverflow?: CSSProperties['overflow']
  $titleRemoved?: boolean
}

const Layout = styled.div<ChildContainerProps>`
  padding: 0px 22px;
  border-radius: 1.3rem;
  min-width: 0px;
  min-height: ${props => props.$childContainerSize || 'calc(100vh - 113px)'};
  flex: 1 1 0%;
  background-color: ${props => props?.theme?.chEnv ? '#DADADA' : 'rgb(241 245 249)'};
  padding-bottom: 2.5rem;
  box-shadow: 0 0 #0000, 0 0 #000000, 0 1px 2px 0 rgb(0 0 0 / 0.05);
`;

const HeaderWrapper = styled.div`
margin-top: 20px !important;
align-items: baseline;
border: none !important;
border-radius: 10px !important;
padding: 8px !important;
`

const LayoutContainer = styled.div`
  padding-left: 1rem;
  padding-right: 1rem;
  max-width: 100%;
  padding: 0px 22px;
  border-radius: 1.3rem;
  min-width: 0px;
  padding-bottom: 2.5rem;
`;

const PageHeaderContainer = styled.div<{ $actionAlignToTop?: boolean }>`
  z-index: calc(50 - 1);
  display: flex;
  position: relative;
  align-items: ${props => props.$actionAlignToTop ? 'flex-start' : 'baseline'};
  flex-direction: row;
  justify-content: space-between;
  margin: auto;
  padding: 10px;
  gap: 15px;
`;

const PageHeaderWrapper = styled.div`
  display: flex;
  align-items: baseline;  
`
const PageHeaderTitle = styled(Header) <HeaderStyledProps>`
  line-height: 1.75rem;
  font-size: ${props => props.fontSizeHeader ? props.fontSizeHeader : '21px'};
  font-weight: 600;
  margin: 0;
  margin-right: 20px;
  white-space: ${props => props.whiteSpaceHeaderProps ? props.whiteSpaceHeaderProps : 'pre'};
  & > span {
    line-height: 1.75rem;
    font-size: 21px;
    font-weight: 600;
    margin: 0;
    white-space: pre;
    font-size: 21px !important;
  }
`;

const PageHeaderActions = styled.div<PageHeaderActionsProp>`
  min-width: ${props => props.actionWidth || 'auto'};
  display: flex;
  margin-top: 0px;
  flex-wrap: ${props => props.$actionNoWrap ? 'no-wrap' : 'wrap'};  
  gap: 5px;
  button,a {
    &:hover {
      color: #ffffff !important;
      background-color: ${props => props.theme.secondColor || 'rgb(26, 49, 117, 0.9)'} !important;
    }
  }
`;

const PageHeaderActionButton = styled(Button)`
  display: inline-flex;
  cursor: pointer;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 0.375rem !important;
  border-width: 1px !important;
  font-size: 1rem !important;
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
  padding-left: 1.75rem !important;
  padding-right: 1.75rem !important;
  font-size: 1.15rem !important;
  font-weight: 500 !important;
  color: #ffffff !important;
  box-shadow: 0 0 #000000, 0 0 #000000, 0 4px 6px -1px rgb(0, 0, 0, 0.1),
    0 2px 4px -2px rgb(0, 0, 0, 0.1) !important;

  & > div {
  font-size: 1.15rem !important;
  font-weight: 500 !important;
  }
`;

const PageHeaderActionBackButton = styled(Button)`
  background: transparent !important;
  opacity: 1 !important;
  margin-right: 1rem;
  i {
    &:hover {
    color: ${props => props.theme.secondColor || '#556080'} !important;
    }
  }
`;

const DimmerContainer = styled(Dimmer)`
  border-radius: 1.3rem;
`;

const ChildContainer = styled.div<ChildContainerProps>`
overflow-x: ${props => props.$childrenOverflow ? props.$childrenOverflow : 'auto'};
overflow-y: ${props => props.$childrenOverflow ? props.$childrenOverflow : 'hidden'};
padding: 0px 10px;
margin-top: ${props => props.$titleRemoved ? '2em !important' : '1em'};
position: relative;
min-height: ${props => props.$childContainerSize || '70vh'};
border: none !important;
border-radius: 10px !important;
`

const FooterWrapper = styled.div`
padding: 10px 0px;
position: absolute;
left: calc(50% - 157px);
bottom: 0;
 i {
  border: 1px solid #3498db;
  padding: 4px;
  border-radius: 10px;
  background: #354E96;
  color: white;
 }
`

export const El = {
  Layout,
  PageHeaderContainer,
  PageHeaderTitle,
  PageHeaderActions,
  PageHeaderActionButton,
  PageHeaderActionBackButton,
  LayoutContainer,
  DimmerContainer,
  PageHeaderWrapper,
  HeaderWrapper,
  ChildContainer,
  FooterWrapper
};
